export default "__VITE_ASSET__Cn3Cfnu7__"